import { useContext } from 'react';

import Axios from 'axios';

import { ListContext } from '@contexts/ListContext';
import { useUserPermission } from '@contexts/UserContext';

/**
 * Creazione di un tag dal punto in cui serve, senza passare da Tag Management.
 *
 * I tag creati da qui sono sempre pubblici: non si creano tag privati in nessun caso.
 * Serve percio' la policy `CreatePublicTags`; senza, l'hook restituisce null e il chiamante
 * non mostra affatto la creazione al volo.
 *
 * Restituisce il tag creato, cosi' il chiamante puo' applicarlo subito all'oggetto.
 */
const useCreateTag = (itemType) => {
    const { UpdateCachedList } = useContext(ListContext);
    const canCreateTags = useUserPermission('CreatePublicTags');

    if (!canCreateTags) {
        return null;
    }

    return async (name) => {
        await Axios.post('/tags', {
            Name: name,
            ID: 0,
            ItemType: itemType,
            PrivacyLevel: 'Public',
        });

        // UpdateCachedList ricarica la lista e la restituisce: il tag creato si ritrova li' dentro,
        // senza dipendere da cosa risponde la POST.
        const refreshedList = await UpdateCachedList('publictags');
        const createdTag = refreshedList?.items?.find(
            (tag) => tag.TagTypeName === itemType && tag.Name.toLowerCase() === name.toLowerCase()
        );

        return createdTag ? { ID: createdTag.ID, Name: createdTag.Name } : null;
    };
};

export default useCreateTag;
